<div class="bg-dashboard">
  <div class="img-container">
    <img src="../assets/images/dashboard.jpg" />
  </div>
</div>